import { render, staticRenderFns } from "./CRUDTermoDeUso.vue?vue&type=template&id=d6da885a"
import script from "./CRUDTermoDeUso.vue?vue&type=script&lang=ts"
export * from "./CRUDTermoDeUso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports